<template>
    <div>
        <b-form-group :description="helpText"
                      :state="isValid"
                      :invalid-feedback="invalidFeedback">
            <b-form-checkbox :id="fieldId" :checked="value" @change="changeValue" :state="isValid">
                <label class="form-label" :for="fieldId">{{ field.label }}</label>
            </b-form-checkbox>
        </b-form-group>
    </div>
</template>

<script>
    import fieldMixin from "@/components/fields/FieldMixin";

    export default {
        name: "CheckboxField",
        mixins: [fieldMixin],
    };
</script>

<style scoped>

</style>